import useLocaleLink from 'hooks/useLocaleLink';

interface BreadcrumbProps {
  items: { label: string; href?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const localeLink = useLocaleLink();

  return (
    <nav className="-mx-4 flex min-w-0 items-center gap-2 overflow-x-auto px-4 text-base leading-6 pad:mx-0 pad:overflow-x-visible pad:px-0 pad:text-md">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const href = item.href ? `${localeLink}${item.href}` : undefined;
        return (
          <span
            key={index}
            className={`flex items-center gap-2 ${isLast ? 'max-w-[240px] overflow-hidden' : 'shrink-0'}`}
          >
            {index > 0 && <span className="shrink-0 text-base-label-40">/</span>}
            {isLast || !href ? (
              <span className="truncate text-base-label">{item.label}</span>
            ) : (
              <a href={href} className="whitespace-nowrap text-base-label-40 transition-colors hover:text-base-label">
                {item.label}
              </a>
            )}
          </span>
        );
      })}
    </nav>
  );
}
